import React from "react"
import "../../../style/modal.css";
import "../ads/ads.css"
import ApiService from "../../../Services/ApiService";


class BidModal extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            campaign_id: '',
            company_id: '',
            bid_amount: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.campaignID !== '' && nextProps.companyID !== '') {
            this.setState({...this.state,
                campaign_id: nextProps.campaignID,
                company_id: nextProps.companyID
            });
        }
    }

    handleChange(e) {
        this.setState({...this.state, bid_amount: e.target.value});
    }

    handleSave() {
        ApiService.post("/api/campaigns/update-linkedin-company",
            {
                campaign_id: this.state.campaign_id,
                linkedin_company_id: this.state.company_id,
                bid_amount: this.state.bid_amount
            })
            .then(response => {
                this.onClose();
                this.props.fetchCompanies();
            })
    }

    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };

    render() {
        return (
            <div className="modal" id="bid-modal">
                <div className="modal-content small-modal">
                    <form>
                        <label>New Bid Amount</label>
                        <input type="text" onChange={this.handleChange}/>
                    </form>
                    <div className="actions">
                        <button onClick={this.onClose}> Close </button>
                        <button className="submitButton"
                                type="submit" onClick={this.handleSave}>Save
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default BidModal;